import logo from "../../assets/logoCopie.png";

const CookiesPolicy = () => {
  document.title = "Dev'Alls - Politique de Cookies";

  return (
    <main className="mainLegales">
      <section className="sectionLegale">
        <div className="retourFleche">
          <p>
            <a className="retour" href="/privacypolicy">
              <span className="returnHome">{"<"}</span> Retour
            </a>
          </p>
        </div>
        <div className="containLogo">
          <a className="navbar-brand" href="/devalls">
            <img src={logo} className="logo_mentions" alt="logo" />
          </a>
        </div>
        <div className="divLegales">
          <h1 className="h1Mentions">Politique de Cookies</h1>

          <section className="legalNotice">
            <h2 className="h2Mentions">1. Introduction</h2>
            <div className="pMentions">
              <p>
                Cette politique de cookies a pour but de vous informer sur
                l'utilisation des cookies sur notre site web. En visitant notre
                site, vous consentez à l'utilisation de cookies conformément à
                cette politique.
              </p>
            </div>
          </section>

          <section className="legalNotice">
            <h2 className="h2Mentions">2. Qu'est-ce qu'un cookie ?</h2>
            <div className="pMentions">
              <p>
                Un cookie est un petit fichier texte qui est stocké sur votre
                appareil lorsque vous visitez un site web. Il permet au site de
                vous reconnaître lors de vos prochaines visites et d'améliorer
                votre expérience de navigation.
              </p>
            </div>
          </section>

          <section className="legalNotice">
            <h2 className="h2Mentions">3. Types de cookies utilisés</h2>
            <div className="pMentions">
              <p>Nous utilisons plusieurs types de cookies sur notre site :</p>
              <ul className="ulMentions">
                <li>
                  <strong>Cookies essentiels :</strong> Ces cookies sont
                  nécessaires au bon fonctionnement du site. Ils permettent la
                  navigation sur notre site et l'accès à certaines
                  fonctionnalités.
                </li>
                <li>
                  <strong>Cookies de performance :</strong> Ces cookies nous
                  permettent d'analyser l'utilisation de notre site, d'améliorer
                  son contenu et de personnaliser l'expérience utilisateur.
                </li>
                <li>
                  <strong>Cookies fonctionnels :</strong> Ces cookies permettent
                  de mémoriser vos préférences et de vous offrir une expérience
                  plus personnalisée.
                </li>
                <li>
                  <strong>Cookies publicitaires :</strong> Ces cookies sont
                  utilisés pour diffuser des annonces en fonction de vos
                  intérêts.
                </li>
              </ul>
            </div>
          </section>

          <section className="legalNotice">
            <h2 className="h2Mentions">4. Comment contrôler les cookies</h2>
            <div className="pMentions">
              <p>
                Vous pouvez à tout moment refuser l'utilisation de certains
                cookies en modifiant les paramètres de votre navigateur.
                Toutefois, cela peut affecter certaines fonctionnalités du site.
                Vous pouvez également supprimer les cookies déjà installés sur
                votre appareil à partir des paramètres de votre navigateur.
              </p>
              <p>
                Pour plus d'informations sur la gestion des cookies, vous pouvez
                consulter la section d'aide de votre navigateur.
              </p>
            </div>
          </section>

          <section className="legalNotice">
            <h2 className="h2Mentions">5. Cookies tiers</h2>
            <div className="pMentions">
              <p>
                Notre site peut également utiliser des cookies tiers (par
                exemple, Google Analytics, services publicitaires, etc.) pour
                analyser le trafic et proposer des publicités personnalisées.
                Ces cookies sont gérés par des entreprises tierces, et vous
                pouvez en savoir plus sur leurs politiques de confidentialité et
                cookies sur leurs sites.
              </p>
            </div>
          </section>

          <section className="legalNotice">
            <h2 className="h2Mentions">
              6. Modifications de la politique de cookies
            </h2>
            <div className="pMentions">
              <p>
                Nous nous réservons le droit de modifier cette politique de
                cookies à tout moment. En cas de changement, la date de la
                dernière mise à jour sera indiquée au bas de cette page.
              </p>
            </div>
          </section>

          <div className="pMentions">
            <p className="mt-4 text-gray-600">
              Dernière mise à jour : 10/02/2025
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default CookiesPolicy;
